import calendar from '../assets/start-stop-01-kalender.jpg'
import order from '../assets/start-stop-02-auftrag.jpg'
import travelRunning from '../assets/start-stop-03-anfahrt-laeuft.jpg'
import feedback from '../assets/start-stop-04-rueckmeldung.jpg'
import workStarted from '../assets/start-stop-05-arbeit-gestartet.jpg'
import workDone from '../assets/start-stop-06-arbeit-beenden.jpg'
import complete from '../assets/start-stop-07-abschliessen.jpg'
import followUp from '../assets/start-stop-08-folgetermin.jpg'
import saved from '../assets/start-stop-09-gespeichert.jpg'
import departure from '../assets/start-stop-10-abfahrt.jpg'
import endDeparture from '../assets/start-stop-11-abfahrt-beenden.jpg'
import closed from '../assets/start-stop-12-abgeschlossen.jpg'
import calendarDone from '../assets/start-stop-13-kalender-fertig.jpg'
import { makeBox, type GuideStepContent } from './guideStep'

/** These screenshots were measured at 642×1389. */
const box = makeBox(642, 1389)

export const TERMIN_ABLAUF_INTRO =
  'Ein Termin hat drei Abschnitte: Anfahrt, Arbeit und Abfahrt. Mit den grünen Knöpfen unten im Auftrag sagen Sie dem Werkhof, wo Sie gerade sind — so stimmen Ihre Zeiten und das Büro sieht Ihren Stand im Kalender.'

export const TERMIN_ABLAUF_STEPS: GuideStepContent[] = [
  {
    title: 'Termin im Kalender öffnen',
    text: 'Auf der Startseite sehen Sie Ihren Kalender. Der Termin hat oben „Anfahrt“ und unten „Abfahrt“. Tippen Sie auf den Termin, um den Auftrag zu öffnen.',
    image: calendar,
    imageAlt: 'Kalender mit einem geplanten Termin',
    focus: [box(74, 508, 262, 728)],
  },
  {
    title: 'Auftrag ansehen',
    text: 'Hier steht alles zum Termin: Datum und Uhrzeit, die geplanten Zeiten für Anfahrt, Arbeit und Abfahrt, die Adresse (mit „Route“) und der Mieter (mit „Anrufen“ und „E-Mail“). Weiter unten folgen Gewerk, Schadensbeschreibung und Anhänge.',
    image: order,
    imageAlt: 'Reparaturauftrag mit Termin, Zeiten, Adresse und Mieter',
    focus: [box(25, 285, 617, 474), box(25, 495, 617, 652), box(25, 672, 617, 816), box(25, 837, 617, 1040)],
  },
  {
    title: 'Anfahrt starten',
    text: 'Tippen Sie unten auf „Anfahrt starten“, sobald Sie sich auf den Weg zum Termin machen. Das gilt, wenn Sie vom Werkhof losfahren, und auch, wenn Sie vom vorherigen Termin kommen.',
    image: order,
    imageAlt: 'Auftrag mit dem Knopf „Anfahrt starten“',
    focus: [box(38, 1258, 312, 1326)],
  },
  {
    title: 'Anfahrt läuft',
    text: 'Der Status ist jetzt „Anfahrt läuft“ und die Fahrzeit zählt mit. Stehen Sie an der Tür des Mieters, tippen Sie auf „Arbeit starten“.',
    image: travelRunning,
    imageAlt: 'Auftrag mit Status „Anfahrt läuft“ und dem Knopf „Arbeit starten“',
    focus: [box(50, 310, 214, 354), box(38, 1258, 605, 1326)],
  },
  {
    title: 'Beschreibung und Anhänge lesen',
    text: 'Scrollen Sie im Auftrag nach unten. Unter „Schadensbeschreibung“ beschreibt das Büro, worum es geht, und unter „Anhänge“ kann es Fotos oder Dateien hinterlegt haben. Beides hilft Ihnen zu verstehen, was beim Termin zu tun ist. Lesen Sie es am besten schon vor der Ankunft.',
    image: feedback,
    imageAlt: 'Auftrag mit Schadensbeschreibung und Anhängen',
    focus: [box(25, 310, 617, 563), box(25, 584, 617, 698)],
  },
  {
    title: 'Notiz oder Foto ans Büro',
    text: 'Weiter unten, unter „Rückmeldung an das Büro“ können Sie während des Termins eine Notiz schreiben („Kommentar speichern“) oder ein Foto bzw. eine Datei hinzufügen. Das dient der internen Dokumentation. Das Büro sieht in seinem Kalender, dass Sie etwas vermerkt haben.',
    image: feedback,
    imageAlt: 'Karte „Rückmeldung an das Büro“ mit Kommentarfeld und Dateien',
    focus: [box(50, 785, 593, 995), box(50, 1103, 593, 1175)],
  },
  {
    title: 'Arbeit starten',
    text: 'Tippen Sie auf „Arbeit starten“. Der Status wechselt zu „In Bearbeitung“ und die Arbeitszeit läuft. Unten steht „Gespeichert“ mit „Rückgängig“: Haben Sie zu früh getippt, nehmen Sie den Start damit zurück.',
    image: workStarted,
    imageAlt: 'Auftrag „In Bearbeitung“ mit „Gespeichert“ und „Rückgängig“',
    focus: [box(38, 1238, 285, 1325)],
  },
  {
    title: 'Arbeit beenden',
    text: 'Haben Sie den Reparaturauftrag ausgeführt, haben Sie zwei Möglichkeiten. „Abschließen“ beendet den Termin erfolgreich. „Folgetermin“ wählen Sie, wenn die Arbeit noch nicht fertig ist und ein weiterer Termin nötig wird.',
    image: workDone,
    imageAlt: 'Auftrag mit den Knöpfen „Abschließen“ und „Folgetermin“',
    focus: [box(38, 1258, 312, 1326), box(325, 1258, 605, 1326)],
  },
  {
    title: 'Termin abschließen',
    text: 'Das Fenster zeigt Startzeit und Dauer. Kommentar und Dateien (zum Beispiel ein Foto) sind freiwillig — tippen Sie darauf, um sie aufzuklappen. Bestätigen Sie mit „Arbeit abschließen“.',
    image: complete,
    imageAlt: 'Fenster „Arbeit abschließen“ mit Kommentar und Dateien',
    focus: [box(50, 633, 583, 752), box(50, 826, 583, 928), box(50, 952, 593, 1018)],
  },
  {
    title: 'Folgetermin anfordern',
    text: 'Wählen Sie die Begründung, warum ein Folgetermin nötig ist. Kommentar und Datei sind auch hier freiwillig. Bestätigen Sie mit „Folgetermin erforderlich“. Das Büro plant dann den nächsten Termin.',
    image: followUp,
    imageAlt: 'Fenster „Folgetermin erforderlich“ mit Begründung',
    focus: [box(50, 565, 583, 630), box(50, 1021, 593, 1088)],
  },
  {
    title: 'Zeiterfassung gespeichert',
    text: 'Die Meldung „Zeiterfassung wurde erfolgreich gespeichert“ bestätigt, dass die Arbeit erfasst ist. Tippen Sie auf „Schließen“. Jetzt läuft die Abfahrt.',
    image: saved,
    imageAlt: 'Meldung „Zeiterfassung wurde erfolgreich gespeichert“',
    focus: [box(97, 810, 545, 892)],
  },
  {
    title: 'Abfahrt beenden',
    text: 'Am Ende Ihres Arbeitstags tippen Sie auf „Abfahrt beenden“ — erst dann, wenn Sie angekommen sind, zum Beispiel am Werkhof.',
    note: {
      title: 'Die Abfahrt gibt es nicht immer',
      text: 'Folgt direkt ein weiterer Termin, ist die Fahrt dorthin nur ein Transfer. Sie wird als „Anfahrt“ beim nächsten Termin erfasst — „Abfahrt beenden“ tippen Sie dann nicht.',
    },
    image: departure,
    imageAlt: 'Auftrag mit Status „Abfahrt läuft“ und dem Knopf „Abfahrt beenden“',
    focus: [box(38, 1258, 605, 1326)],
  },
  {
    title: 'Abfahrt bestätigen',
    text: 'Das Fenster zeigt, wann die Arbeit endete und wie lange die Abfahrt dauerte. Tippen Sie auf „Abfahrt beenden“.',
    image: endDeparture,
    imageAlt: 'Fenster „Abfahrt beenden“',
    focus: [box(50, 769, 593, 835)],
  },
  {
    title: 'Termin abgeschlossen',
    text: 'Der Status ist jetzt „Abgeschlossen“. Auch hier bestätigt die Meldung, dass alles gespeichert wurde. Tippen Sie auf „Schließen“.',
    image: closed,
    imageAlt: 'Auftrag „Abgeschlossen“ mit Bestätigung',
    focus: [box(50, 310, 233, 354), box(97, 810, 545, 892)],
  },
  {
    title: 'Im Kalender kontrollieren',
    text: 'Zurück im Kalender zeigt der Termin Ihre tatsächlichen Zeiten: Er ist grün, und Anfahrt, Arbeit und Abfahrt sitzen so, wie Sie sie erfasst haben.',
    image: calendarDone,
    imageAlt: 'Kalender mit dem abgeschlossenen, grünen Termin',
    focus: [box(74, 515, 262, 675)],
  },
]
